import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "menu" }
const _hoisted_2 = { id: "menu-wrapper" }
const _hoisted_3 = {
  key: 0,
  id: "menu-area"
}
const _hoisted_4 = { class: "category" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "menu-list" }
const _hoisted_7 = {
  key: 1,
  id: "menu-area"
}
const _hoisted_8 = {
  key: 2,
  id: "session-area"
}
const _hoisted_9 = ["title"]
const _hoisted_10 = {
  key: 3,
  id: "session-area"
}
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "obj" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.menuInfo != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuInfo.categoryList, (category, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                id: "category-area"
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(category.name), 1)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.menuList, (menuItem, menuIndex) => {
                    return _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                      key: menuIndex,
                      to: menuItem.path,
                      class: "menu"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: _normalizeClass(["label", { active: _ctx.isMenuActive(menuItem) }])
                        }, _toDisplayString(menuItem.name), 3)
                      ]),
                      _: 2
                    }, 1032, ["to"])), [
                      [_vShow, menuItem.name]
                    ])
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7)),
      (_ctx.loginInfo.userId == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "obj clickable theme-toggle",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleTheme())),
              title: _ctx.isDark() ? '라이트 모드로 전환' : '다크 모드로 전환'
            }, _toDisplayString(_ctx.isDark() ? '☀️' : '🌙'), 9, _hoisted_9),
            _createElementVNode("div", {
              class: "obj clickable",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickLogin()))
            }, "로그인"),
            _createElementVNode("div", {
              class: "obj clickable",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickJoin()))
            }, "회원가입")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", {
              class: "obj clickable theme-toggle",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleTheme())),
              title: _ctx.isDark() ? '라이트 모드로 전환' : '다크 모드로 전환'
            }, _toDisplayString(_ctx.isDark() ? '☀️' : '🌙'), 9, _hoisted_11),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.loginInfo.id), 1),
            _createElementVNode("div", {
              class: "obj clickable",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickMyInfo()))
            }, "마이페이지"),
            _createElementVNode("div", {
              class: "obj clickable",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clickLogout()))
            }, "로그아웃")
          ]))
    ])
  ]))
}